import styled from "styled-components"
import { useContext } from "react"
import { LanguageContext } from "../context/LanguageContext"
import { useState, useEffect } from "react"

const ProjectsAnimation = () => {
    const { lang } = useContext(LanguageContext)
    const reelsNames = ["Animation Reel 2024", "TikToks", "Unreleased 3D film", "Moose", "Central Park", "F is for Family", "Kulipari", "Les Grandes Gueules s'animent", "Give a mouse a cookie", "Pickle and Peanut"]
    const schoolReelsNames = ["Move", "NAD Animations"]
    const tiktoks = "https://www.youtube.com/embed/h1CPOgsveZI?si=7AEWNPngHbCO4oXH&amp;controls=0"
    const anim2024 = "https://www.youtube.com/embed/l4S0fMU9Rqw?si=LJY1CqUEqnXZ6MpD"
    const spaceBears = "https://www.youtube.com/embed/sDy9pgwzkiI?si=RejkWghJRc7k_vIA"
    const moose = "https://www.youtube.com/embed/jAplDgVo0LU?si=Gt23dQ7g354_Rw2a"
    const centralPark = "https://www.youtube.com/embed/hQsXPrjL4xg?si=kMWm6R0QmwsDoXzt"
    const fFamily = "https://www.youtube.com/embed/2sC0-HzLFEM?si=PAk_U4jm7q0Z43jR"
    const kulipari = "https://www.youtube.com/embed/xMcWsRAsfuE?si=W3QW9SCJUdtopBhY"
    const gg = "https://www.youtube.com/embed/Q6QlL4gqJYI?si=d44EjSA4PJyVTKjw"
    const gmac = "https://www.youtube.com/embed/YQW2pzJVEew?si=0pGPH4i7oqtn1qiW"
    const pnp = "https://www.youtube.com/embed/NyuXGooatrw?si=zuRHUMmxiLiOFwjG"
    const moveFilm = "https://player.vimeo.com/video/549885250?h=1c888c1e67&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
    const nadAnim = "https://www.youtube.com/embed/mARxoWSB3iA?si=zhJT8GnivTdRjS9C"
    const [reelVideo, setReelVideo] = useState(anim2024)


    useEffect(() => {
        console.log("Project changed")
    }, [reelVideo])

    return <div id="Projects" className="paleSections scrollable hidden" style={{position: "relative", padding: "5rem 0"}}>
        <div className="hidden" style={{display: "flex", flexDirection: "column", width: "100%"}}>
            {lang === "en" ? <h2>Animation reels</h2> : <h2>Démos d'animation</h2>}
            <div style={{display: "flex", flexWrap: "wrap", alignSelf: "stretch", alignItems: "center", justifyContent: "center"}}>
            <iframe width="1236" height="695" src={reelVideo} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div style={{border: "dashed 3px var(--color-text-light)", padding: "1.5rem"}}>
                    {lang === "en" ? <p style={{textAlign: "right", fontSize: "2.5rem", margin: "0 0 1rem"}}>Professional projects</p> : <p style={{textAlign: "right", fontSize: "2.5rem", margin: "1rem 0"}}>Projets professionnels</p>}
                    {reelsNames.map((reelName) => {
                        return <div style={{textAlign: "right"}}>
                            <a onClick={() => {
                                if(reelName === "Animation Reel 2024"){
                                    setReelVideo(anim2024)
                                }
                                else if(reelName === "TikToks"){
                                    setReelVideo(tiktoks)
                                }
                                else if(reelName === "Unreleased 3D film"){
                                    setReelVideo(spaceBears)
                                }
                                else if(reelName === "Moose"){
                                    setReelVideo(moose)
                                }
                                else if(reelName === "Central Park"){
                                    setReelVideo(centralPark)
                                }
                                else if(reelName === "F is for Family"){
                                    setReelVideo(fFamily)
                                }
                                else if(reelName === "Kulipari"){
                                    setReelVideo(kulipari)
                                }
                                else if(reelName === "Les Grandes Gueules s'animent"){
                                    setReelVideo(gg)
                                }
                                else if(reelName === "Give a mouse a cookie"){
                                    setReelVideo(gmac)
                                }
                                else if(reelName === "Pickle and Peanut"){
                                    setReelVideo(pnp)
                                }
                            }}>
                                {reelName}
                            </a>
                        </div>
                    })}
                    {lang === "en" ? <p style={{textAlign: "right", fontSize: "2.5rem", margin: "1rem 0"}}>School projects</p> : <p style={{textAlign: "right", fontSize: "2.5rem", margin: "1rem 0"}}>Projets d'école</p>}
                    {schoolReelsNames.map((schoolReelName) => {
                        return <div style={{textAlign: "right"}}>
                            <a onClick={() => {
                                if(schoolReelName === "Move"){
                                    setReelVideo(moveFilm)
                                }
                                else if(schoolReelName === "NAD Animations"){
                                    setReelVideo(nadAnim)
                                }
                            }}>{schoolReelName}</a>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </div>
}

export default ProjectsAnimation